import { Component, HostListener, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterModule } from '@angular/router'
import { AuthFacade, PetsFacade } from 'auth'
import { CDN } from 'src/app/core/constants'
import { AppNavMenuComponent } from './app-nav-menu/app-nav-menu.component'
import { AppProfileMenuComponent } from './app-profile-menu/app-profile-menu.component'
import { AppHeaderActionsComponent } from './app-header-actions/app-header-actions.component'

@Component({
  selector: 'ex-app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, AppNavMenuComponent, AppProfileMenuComponent, AppHeaderActionsComponent],
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent {

  isNavOpen = false
  isProfileOpen = false

  readonly logoSVG = `${CDN.url}logo_explorer-header.svg`

  #authFacade = inject(AuthFacade)
  #petsFacade = inject(PetsFacade)
  router = inject(Router)

  isAuthenticated = this.#authFacade.isAuthenticated
  profile = this.#authFacade.profile
  currentPet = this.#petsFacade.currentPet

  toggleNav() {
    this.isNavOpen = !this.isNavOpen
    if (this.isNavOpen) this.isProfileOpen = false
  }

  toggleProfile() {
    this.isProfileOpen = !this.isProfileOpen
    if (this.isProfileOpen) this.isNavOpen = false
  }

  redirectHome() {
    this.router.navigateByUrl(this.isAuthenticated() ? '/dashboard' : '/')
  }

  @HostListener('document:keydown.escape')
  closeAll() {
    this.isNavOpen = false
    this.isProfileOpen = false
  }

}
